module.exports = __webpack_public_path__ + "img/interrogation.3ab52b05.png";